export default __webpack_public_path__ + "static/media/phone.92799eed.gif";